import { SITE, LANGUAGES } from '@/constants'

export const cleanOrigin = (path = '') => {
  const origin = process.env.NODE_ENV === 'development' ? SITE : window.location.origin
  const clean = path.replace(origin, '')
  if (clean.startsWith('/')) return clean
  return `/${clean}`
}

export const isInternal = (to) => {
  const origin = process.env.NODE_ENV === 'development' ? SITE : window.location.origin
  if (to === undefined || to === '' || to === null) return false
  const linkSplit = to.split('/')
  if (to.indexOf(origin) === 0) return true
  if (to.indexOf('://') === -1) return true
  if (linkSplit[linkSplit.length - 1].indexOf('.') === -1) return false
  return window.location.hostname === to.hostname
}

export const isFile = (url = '') => {
  const cleanedUrl = cleanOrigin(url)
  const ext = cleanedUrl.split('.')
  return ext.length > 1 && ext.pop().length >= 2
}

export const getUrlWithoutOrigin = (pathname = '') => {
  const origin = process.env.NODE_ENV === 'development' ? SITE : window.location.origin
  return pathname.replace(origin, '')
}

export const getSlug = (pathname = '') => {
  const pathArray = pathname.split('/').filter((p) => p !== '')
  return pathArray.slice(pathArray.length - 1)[0]
}

export const slugify = (string) => {
  if (!string) return ''
  const from = 'ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;'
  const to = 'aaaaaeeeeeiiiiooooouuuunc------'

  const newText = string.split('').map(
    (letter, i) => letter.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i)),
  )

  return newText
    .toString() // Cast to string
    .toLowerCase() // Convert the string to lowercase letters
    .trim() // Remove whitespace from both sides of a string
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/&/g, '-y-') // Replace & with 'and'
    .replace(/[^\w\-]+/g, '') // eslint-disable-line
    .replace(/\-\-+/g, '-') // eslint-disable-line
}

export const internazionalizePath = (path, langs = LANGUAGES) => {
  if (langs.length < 2) return path
  const originalPaths = Array.isArray(path) ? path : Array(path)
  const intPaths = originalPaths.reduce((acc, item) => {
    return acc.concat(langs.map((l) => `/${l}${item}`))
  }, [])
  return intPaths
}

export const getPathFromCpt = (routing, cpt, param = '') => {
  return routing.map((route) => {
    if (route.cpt === cpt) return `/${route.slug}${param !== '' ? `/:${param}` : ''}`
    return null
  }).filter((el) => el !== null)
}

export const removeTrailingSlash = (str) => (str.endsWith('/') ? str.slice(0, -1) : str)

export const checkSubcategorySlug = (slug, string) => (slug.toLowerCase() === string?.toLowerCase() ? '' : slug)

export const containsUrl = (url, string) => {
  const origin = SITE || window.location.origin
  const clean = string.replace(origin, '')
  return url.includes(clean.toLowerCase())
}

export const replaceLastSegment = (url, string) => {
  const str = removeTrailingSlash(url)
  const newStr = str.slice(0, str.lastIndexOf('/'))
  return `${newStr}/${string}`
}

export const getExtension = (path) => path.split('.').pop()

export const getFilename = (path) => path.substring(path.lastIndexOf('/') + 1)

export const getYoutubeVideoId = (url) => {
  const youtubeRegex = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:embed\/|watch\?v=|v\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i
  const match = url.match(youtubeRegex)
  if (match && match[1]) {
    return match[1]
  }
  return null
}
